<script>
import RecycleModal from './RecycleModal.vue'
import FailModal from './FailModal.vue'
import ModalConfirm from '../../ModalConfirm.vue';
import moment from 'moment'

export default {
    components: {
        RecycleModal,
        FailModal,
        ModalConfirm
    },

    props: {
        jobApplication: {
            type: Object,
            required: true
        },
        csrfToken: {
            type: String,
            required: true
        },
        logs: {
            type: Object,
            required: false
        },
    },

    data() {
        return {
            average: 0,
            fail_reason: '',
            passBtnDisabled: false,
            language_proficiency_status: this.jobApplication.language_proficiency_status,
            voiceWillBeDeleted: null,
            progress_submission_status: ''
        }
    },

    mounted() {
        this.setAverageScore()
    },

    methods: {
        toggleModal(ref) {
            this.$refs[ref].toggleModal()
        },

        setAverageScore() {
            if (this.jobApplication.language_proficiency_scores.length === 0) {
                this.average = 0
            }

            const average = this.jobApplication.language_proficiency_scores.reduce((acc, langProfScore) => acc + parseInt(langProfScore.score), 0) / this.jobApplication.language_proficiency_scores.length

            this.average = Math.round(average)
        },
        fail(fail_reason) {
            this.fail_reason = fail_reason
            this.$nextTick(() => {
                this.$refs.failedButton.click();
            });
        },
        disablePassBtn(event) {
            event.preventDefault();

            this.passBtnDisabled = true;
            this.language_proficiency_status = 'passed';

            const clickedButtonValue = event.submitter.value;

            if (clickedButtonValue === 'progress_submission') {
                this.progress_submission_status = clickedButtonValue;
            }

            if (clickedButtonValue === 'request_resubmission') {
                this.language_proficiency_status = 'request_resubmission';
            }

            if (clickedButtonValue === 'failed') {
                this.language_proficiency_status = 'failed';
            }

            setTimeout(() => {
                this.$refs.languageProficiencyForm.submit();
            }, 500);
        },
        submitDeleteVoice() {
            this.$refs.form.submit();
        },


        confirmDeleteVoice(id) {
            this.voiceWillBeDeleted = id
            this.toggleModal('confirmModal')
        },

        convertDate(date, format = 'YYYY-MM-DD HH:mm') {
            return moment.parseZone(date).format(format)
        },
    },

    mounted() {
        if (this.jobApplication.language_proficiency_status == 'passed') {
            this.passBtnDisabled = true;
        }
    },

    watch: {
        //watch jobApplication deep true
        jobApplication: {
            handler: function (newVal, oldVal) {
                this.passBtnDisabled = false;
                if (newVal.language_proficiency_status == 'passed') {
                    this.passBtnDisabled = true;
                }
            },
            deep: true
        }
    }
}
</script>

<template>
    <div class="language-proficiency">
        <form method="post" @submit="disablePassBtn" ref="languageProficiencyForm">
            <input type="hidden" name="_csrfToken" :value="csrfToken" />
            <input type="hidden" name="fail_reason" :value="fail_reason" />
            <input type="hidden" name="language_proficiency_status" :value="language_proficiency_status">

            <div v-for="(langProf, i) in jobApplication.language_proficiency_scores" class="bg-white rounded p-3 pt-2" :class="{'pb-0': i < jobApplication.language_proficiency_scores.length - 1}" :key="langProf.id">
                <div class="grid-x grid-padding-x mb-3">
                    <div class="cell small-6">
                        <input type="hidden" :name="`language_proficiency_scores[${i}][id]`" :value="langProf.id" />

                        <label>Recording {{ i + 1 }}:</label>

                        <div class="mb-2 mt-2">
                            <audio v-if="langProf.file_path !== null" controls>
                                <source :src="`${langProf.file_path_cdn}`" type="audio/mpeg">
                                Your browser does not support the audio element.
                            </audio>
                            <div v-else>Voice note record unavailable</div>
                        </div>

                        <div class="form-control px-0 mb-2">
                            <p><a class="text-danger" @click="confirmDeleteVoice(langProf.id)">Delete</a></p>
                            <p>Algorithm Score: <strong><i>{{ langProf.confidence }}%</i></strong></p>
                            <p>Recruiter score:</p>

                            <div class="d-flex align-items-center gap-2">
                                <input
                                    type="number"
                                    step="1"
                                    min="0"
                                    max="100"
                                    required
                                    class="mt-2"
                                    :name="`language_proficiency_scores[${i}][score]`"
                                    v-model="langProf.score"
                                    style="width: unset;"
                                    @change="setAverageScore"
                                />
                                <span>%</span>
                            </div>
                        </div>
                    </div>

                    <div class="cell small-4 lang-prof-desc">
                        <p class="mt-4">{{ langProf.text }}</p>
                    </div>

                </div>
                <hr v-if="i < jobApplication.language_proficiency_scores.length - 1">
            </div>

            <p v-if="jobApplication.language_proficiency_scores.length === 0">Candidate has not uploaded any audio clips</p>

            <template v-if="jobApplication.language_proficiency_scores.length > 0">
                <div class="px-3">
                    <hr style="max-width: unset;" />
                    <span>Average Algorithm Score: </span> <span class=""><strong><i>{{ average }}%</i></strong></span>

                    <br>

                    <template v-if="jobApplication.language_proficiency_status != null">
                        <span>Final Status: </span> <strong>{{ jobApplication.language_proficiency_status }}</strong>
                        <small v-if="logs !== null && logs !== ''">
                            &nbsp;(Updated By {{ logs.user.first_name }} {{ logs.user.last_name }} - {{ convertDate(logs.created) }})
                        </small>
                    </template>
                    <hr style="max-width: unset;" />
                </div>

            </template>

            <template v-else>
                <hr style="max-width: unset;" />
                <span>Final Status: </span> <strong>{{ jobApplication.language_proficiency_status }}</strong>

                <small v-if="logs !== null && logs !== ''">
                    &nbsp;(Updated By {{ logs.user.first_name }} {{ logs.user.last_name }} - {{ convertDate(logs.created) }})
                </small>

                <hr style="max-width: unset;" />
            </template>

            <div class="grid-x grid-padding-x mt-4">
                <div class="cell shrink">
                    <input type="hidden" name="language_proficiency_progress" :value="progress_submission_status">
                    <button class="button success px-5" type="submit" value="progress_submission" :disabled="passBtnDisabled">Save Progress</button>
                </div>
                <div class="cell shrink">
                    <button class="button px-5" type="submit" :disabled="passBtnDisabled">Pass</button>
                </div>
                <div>
                    <button class="d-none" value="failed" ref="failedButton" name="language_proficiency_status"></button>
                    <button class="button alert px-5" type="button" @click="toggleModal('failModal')">Fail</button>
                </div>
                <div class="cell shrink">
                    <button class="button recycle px-5" type="button" @click="toggleModal('recycleModal')">Recycle</button>
                </div>
                <div>
                    <button class="button warning text-white" type="submit" value="request_resubmission">Request Resubmission</button>
                </div>
            </div>

        </form>
        
        <form 
            ref="form"
            method="post" 
            :action="`/recruiter/active-requisitions/delete-voice-note?jobApplication=${jobApplication.id}`"
        >
            <input type="hidden" name="voice_note_id" :value="voiceWillBeDeleted"/>
            <input type="hidden" name="_csrfToken" :value="csrfToken" />
            <button type="submit" class="hide" ref="btnDeleteVoiceNote">Submit</button>
        </form>


        <recycle-modal ref="recycleModal" :job-application="jobApplication" :csrf-token="csrfToken" />
        <fail-modal ref="failModal" :job-application="jobApplication" @submit="fail" />
        <modal-confirm ref="confirmModal" message="Are you sure you want to delete this voice recording?" @confirmed="submitDeleteVoice"/>
    </div>
</template>

<style lang="scss" scoped>
audio {
    background-color: #f2f4f4 !important;
    width: 450px;
    border-radius: 3px;
}

.lang-prof-desc {
    p {
        color: #455666;
        font-weight: normal;
        font-size: .9rem;
        line-height: 1.5;
    }
}
</style>